import { Divider, Grid, Typography } from '@mui/material';
import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { formatString, getContactListPageUrl } from '../../../../../utils/constants';
import { saveAndRemoveContactExecutionData } from '../../../../../models/axiosModel';

export interface SaveAndRemoveContactActionProps {
    actionData: saveAndRemoveContactExecutionData,
    actionType: string,
} 

const SaveAndRemoveContactAction: React.FC<SaveAndRemoveContactActionProps> = (props) => {
    
    const { actionData, actionType } = props;
    
    return (
        <>
            <Grid container className={`${styles.saveVariableActionMainContainer} ${globalStyles.flexColumn}`} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Typography className={styles.customAPICallMsgTitle}>
                        {formatString(actionType)}
                    </Typography>
                </Grid>
                <Divider />
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} flexWrap={"nowrap"} alignItems={"center"}>
                        <Grid item xs={6} className={styles.customAPICallInfoTitle}>
                            Contact List  
                        </Grid> 
                        <Grid item xs={5.5}>
                             <a href={getContactListPageUrl(actionData?.contact_list_id)} target='blank' className={`${styles.contactListAnchorTag} ${globalStyles.secondaryFontSize} ${globalStyles.tertiaryFontWeight}`}>
                                {actionData?.contact_list_name}
                            </a>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default SaveAndRemoveContactAction
